/**
 * État + soumission de la waitlist (liste d'attente) pour /b/[slug].
 */
import { eventsApi } from "~/services/api/events";

export function useEventWaitlist(slug: Ref<string>) {
  const { t } = useI18n();
  const waitlistForm = ref({ name: "", email: "", phone: "" });
  const waitlistLoading = ref(false);
  const waitlistMessage = ref<{ type: "success" | "error"; text: string } | null>(null);

  async function joinWaitlist() {
    if (!waitlistForm.value.name || !waitlistForm.value.email || waitlistLoading.value) return;
    waitlistLoading.value = true;
    waitlistMessage.value = null;
    try {
      const result = await eventsApi.joinWaitlist(slug.value, waitlistForm.value);
      waitlistMessage.value = { type: "success", text: result.message };
    } catch (e: unknown) {
      waitlistMessage.value = { type: "error", text: (e as Error)?.message || t("billetterie.useEventWaitlist.erreurGenerique") };
    } finally {
      waitlistLoading.value = false;
    }
  }

  return { waitlistForm, waitlistLoading, waitlistMessage, joinWaitlist };
}
